import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class SmartTeamsAppPartnerCompanyOption extends MongoEntity {
  static override _class = 'SmartTeamsAppPartnerCompanyOption';
  static override _collectionName = 'smartteams_partnercompanies';

  @Field(() => String)
  name: Maybe<string>;
}
